import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlmacenMenajeriaComponent } from './almacen-menajeria.component';
import {InventarioComponent} from "./inventario/inventario.component";
import {StockComponent} from "./stock/stock.component";
import {IngresoComponent} from "./ingreso/ingreso.component";


//const routes: Routes = [{ path: '', component: AlmacenMenajeriaComponent }];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component:InventarioComponent},
    {path:'stock', component:StockComponent},
    {path:'ingreso', component:IngresoComponent},
  ])],
  exports: [RouterModule]
})
export class AlmacenMenajeriaRoutingModule { }
